import { IUserProfile } from '@core/interfaces/user/user-profile.interface';
import { Gender } from '@core/enums/gender/gender.enum';
import { UserStatus } from '@core/enums/user/user-status.enum';
import { IAdminPartner } from '@core/interfaces/iam/admin-partner.interface';
import { CUSTOMERS } from '../customer/customer.mock';

export const USER_PROFILE: IUserProfile = {
  id: 'user-id1',
  email: 'balazs.varga@interticket.net',
  createdAt: '2018-09-04T13:11:24.705Z',
  picture: '6b4b012e-86ce-4a06-bb13-0018d7453a7d',
  firstName: 'Balázs',
  lastName: 'Varga',
  motherName: null,
  maidenName: null,
  birthPlace: null,
  birthDate: '1991-09-04',
  gender: Gender.MALE,
  birthName: null,
  phoneNumber: null,
  roles: ['system admin'],
  partnerName: 'I AM PARTNER',
  emailConfirmed: true,
  status: UserStatus.ACTIVE,
  customer: CUSTOMERS[0],
};

export const ADMIN_PARTNERS: IAdminPartner[] = [
  {
    name: 'oartner partner',
    partnerId: '6f7cc4c6-7a03-4be6-aaff-0b6aee7f823b',
    current: true,
  },
  {
    name: 'lochnessi rajmundó sínház',
    partnerId: 'de70dc54-b7dd-4bb7-a4cb-fb8f87d4253e',
    current: false,
  },
];
